<!--
 * @Description: 修改密码
 * @Author: tanglitong
 * @CreationDate: 2023/2/20 15:43
-->
<template>
  <div class="ChangePasswordBase">
    <section>
      <div class="steps_content">
        <el-steps :active="active">
          <el-step>
            <template v-slot:icon>
              <div>1</div>
              <span>{{ isBind ? '绑定' : '验证' }}手机号</span>
            </template>
          </el-step>
          <el-step>
            <template v-slot:icon>
              <div>2</div>
              <span>设置新密码</span>
            </template>
          </el-step>
          <el-step>
            <template v-slot:icon>
              <div>3</div>
              <span>完成更改</span>
            </template>
          </el-step>
        </el-steps>
      </div>
      <div class="form_content">
        <el-form ref="formRef" :model="form" :rules="formRules" label-suffix="：" label-width="120px" size="medium">
          <div v-show="active === 0">
            <!--脱敏手机号展示-->
            <el-form-item v-if="!isBind" label="手机号" prop="mobileTm">
              <el-input v-model="form.mobileTm" :maxlength="11" autocomplete="off" placeholder="请输入手机号码"
                readonly style="width: 440px"></el-input>
            </el-form-item>
            <!--绑定手机号输入-->
            <el-form-item v-else label="手机号" prop="mobile">
              <el-input v-model="form.mobile" :maxlength="11" autocomplete="off"
                placeholder="请输入手机号码" style="width: 440px"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="code">
              <el-input v-model="form.code" :maxlength="6" autocomplete="off"
                placeholder="请输入短信验证码" style="width: 302px"></el-input>
              <el-button :disabled="timer.countDown < 60" :loading="loading" style="width: 135px" type="primary"
                @click="performVerify()">
                {{ timer.countDownText }}
              </el-button>
            </el-form-item>
          </div>
          <div v-show="active === 1">
            <el-form-item :show-message="false" class="no_margin_bottom" label="密码" prop="password">
              <el-input
                v-model.trim="form.password"
                :maxLength="16" :type="form.showPassword ? 'text' : 'password'"
                autocomplete="new-password"
                placeholder="请输入8-16位包含大小写字母，特殊字符和数字的密码"
                style="width: 440px">
                <i slot="suffix" :class="['el-input__icon', form.showPassword ? 'ri-eye-fill' : 'ri-eye-off-fill']"
                  @click="form.showPassword = !form.showPassword"></i>
              </el-input>
              <div class="form_password_verifiers">
                <el-tag :type="PasswordLengthRge.test(form.password) ? 'success' : 'info'" hit>
                  <i class="el-icon-success"></i>8-16位之间
                </el-tag>
                <el-tag :type="UppercaseLowercaseReg.test(form.password) ? 'success' : 'info'" hit>
                  <i class="el-icon-success"></i>含大小写字母
                </el-tag>
                <el-tag :type="NumberReg.test(form.password) ? 'success' : 'info'" hit>
                  <i class="el-icon-success"></i>含数字
                </el-tag>
                <el-tag :type="SpecialCharactersReg.test(form.password) ? 'success' : 'info'" hit>
                  <i
                    class="el-icon-success"></i>含特殊字符，如:@#*
                </el-tag>
              </div>
            </el-form-item>
            <el-form-item label="确认密码" prop="againPassword">
              <el-input
                v-model="form.againPassword"
                :type="form.showAgainPassword ? 'text' : 'password'"
                autocomplete="new-password"
                placeholder="请再一次输入密码"
                style="width: 440px"
              >
                <i slot="suffix"
                  :class="['el-input__icon', form.showAgainPassword ? 'ri-eye-fill' : 'ri-eye-off-fill']"
                  @click="form.showAgainPassword = !form.showAgainPassword"></i>
              </el-input>
            </el-form-item>
          </div>
          <div v-show="active === 2">
            <div class="set_success">
              <img alt="" src="../../assets/img-4/success-ico.png">
              <p>密码更改成功，点击【完成】重新登录</p>
            </div>
          </div>
        </el-form>
      </div>
    </section>
    <footer slot="footer">
      <template v-if="active === 2">
        <el-button type="primary" @click="nextStep()">完成</el-button>
      </template>
      <template v-else>
        <el-button v-if="active !== 0" type="primary" @click="previousStep()">上一步</el-button>
        <el-button :disabled="active === 2" :loading="nextLoading" type="primary" @click="nextStep()">下一步
        </el-button>
      </template>
    </footer>
    <!-- 滑块验证 -->
    <div class="verify_box">
      <Verify v-if="verifyShow" ref="verifyRef" :captchaType="'blockPuzzle'"
        :imgSize="{ width: '240px', height: '120px'}"
        :mode="'pop'" @close="verifyClose"
        @success="verifySuccess"></Verify>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  CodeReg,
  NumberReg,
  PasswordLengthRge,
  PasswordReg,
  phoneReg,
  SpecialCharactersReg,
  UppercaseLowercaseReg
} from '../../utils/commonReg'
import Verify from '../../components/verifition/Verify.vue'
import { validateAgainPassword } from './index.js'
import { FaceRecognitionStorage } from '../../utils/global-methods'
import Cookies from 'js-cookie'
import { getsms, smsSendByUuid, smsvalidate, smsValidateByUuid } from '../../api/apiLoginVerify'
import { aesEncryptWord } from '../verifition/utils/ase'
import { userUpdatePassword } from '../../api/api'
import { sm3Encrypt } from '../verifition/utils/sm-crypto'
import md5 from 'crypto-js/md5'

export default {
  name: 'ChangePasswordBase',
  components: {
    Verify
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userinfo: {}, //用户信息
      verifyShow: false, //滑块显示
      dialogVisible: false, //修改密码弹窗
      loading: false,
      nextLoading: false,
      active: 0, //步骤
      timer: {
        countDownText: '获取验证码',
        countDown: 60,
        interval: null
      },
      form: {
        mobileTm: '',
        mobile: '',//手机号
        code: '', //短信验证码
        password: '',//密码
        showPassword: false,
        againPassword: '',
        showAgainPassword: false
      },
      formRules: {
        mobileTm: [
          {required: true, message: '请输入正确的手机号码', trigger: 'change'}
        ],
        mobile: [
          {required: true, message: '请输入正确的手机号码', pattern: phoneReg, trigger: 'change'}
        ],
        code: [
          {required: true, message: '请输入正确的短信验证码', pattern: CodeReg, trigger: 'change'}
        ],
        password: [
          {required: true, pattern: PasswordReg, trigger: 'change'}
        ],
        againPassword: [
          {
            required: true, validator: (rule, value, callback) => {
              validateAgainPassword(rule, value, callback, this.form.password)
            }, trigger: 'change'
          }
        ]
      },
      isBind: false,
      PasswordLengthRge,
      UppercaseLowercaseReg,
      NumberReg,
      SpecialCharactersReg
    }
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {},
  created() {
  },
  mounted() {
    this.initPage()
  },
  methods: {
    initPage() {
      if (this.userInfo && this.userInfo.uuid) {
        // this.userInfo.isMobileVerify !== 1
        if (!this.userInfo.mobile || this.userInfo.isMobileVerify !== 1) {
          this.isBind = true
        } else {
          this.form.mobileTm = this.userInfo.mobile
        }
      }
    },
    /**
     * @description: 修改密码
     */
    updatePassword() {
      this.nextLoading = true
      const params = {
        code: this.form.code,
        password: md5(this.form.password).toString(),
        password2: sm3Encrypt(this.form.password),
        uuid: this.userInfo.uuid
      }
      if (this.isBind) params.mobile = this.form.mobile
      userUpdatePassword(params).then(res => {
        this.nextLoading = false
        const {code, msg} = res
        if (code !== 0) {
          this.$message.error(msg)
          return
        }
        this.nextStep(true)
      }).catch(() => {
        this.nextLoading = false
      })
    },
    /**
     * @description: 获取短信验证码 (flag: 1 验证手机号在系统是否存在 2 验证手机号是否被占用)
     */
    getCode(verifyData) {
      this.loading = true
      if (this.isBind) { //绑定手机号 - 修改密码
        const params = {
          uuid: this.userInfo.uuid,
          mobile: aesEncryptWord(this.form.mobile),
          captchaVerification: verifyData.captchaVerification,
          flag: 3
        }
        getsms(params).then((res) => {
          this.loading = false
          const {code, msg, data} = res
          if (code !== 0) {
            this.$message.error(msg)
            return
          }
          this.$message.success(data)
          this.startTimer()
        }).catch(() => {
          this.loading = false
        })
      } else { //验证手机号 - 修改密码
        const params = {
          uuid: this.userInfo.uuid,
          captchaVerification: verifyData.captchaVerification,
          flag: 1
        }
        smsSendByUuid(params).then(res => {
          this.loading = false
          const {code, msg, data} = res
          if (code !== 0) {
            this.$message.error(msg)
            return
          }
          this.$message.success(data)
          this.startTimer()
        }).catch(() => {
          this.loading = false
        })
      }
    },
    /**
     * @description: 验证手机验证码是否正确
     */
    checkCode() {
      this.nextLoading = true
      const params = {
        code: this.form.code
      }
      if (this.isBind) {
        params.mobile = this.form.mobile
      } else {
        params.uuid = this.userInfo.uuid
      }
      const smsApi = this.isBind ? smsvalidate : smsValidateByUuid
      smsApi(params).then(res => {
        this.nextLoading = false
        const {code, msg} = res
        if (code !== 0) {
          this.$message.error(msg)
          return
        }
        this.nextStep(true)
      }).catch(() => {
        this.nextLoading = false
      })
    },
    /**
     * @description: 进行滑块验证
     */
    performVerify() {
      const verifyShow = () => {
        this.loading = true
        this.verifyShow = true
        this.$nextTick(() => {
          this.$refs.verifyRef.show()
        })
      }
      // 绑定手机号 - 修改密码
      if (this.isBind) {
        this.$refs['formRef'].validateField(['mobile'], (valid) => {
          if (valid) return false
          verifyShow()
        })
      } else {
        if (this.userInfo && this.userInfo.uuid) {
          verifyShow()
        } else {
          this.$message.error('登录信息失效')
        }
      }
    },
    /**
     * @description: 滑块成功回调
     */
    verifySuccess(verifyData) {
      this.verifyShow = false
      this.getCode(verifyData)
    },
    /**
     * @description: 滑块关闭回调
     */
    verifyClose() {
      if (this.loading) this.loading = false
    },
    /**
     * @description: 启动计时器
     */
    startTimer() {
      this.timer.interval = setInterval(() => {
        if (this.timer.countDown > 0) {
          this.timer.countDown--
          this.timer.countDownText = `${ this.timer.countDown }s`
        } else {
          clearInterval(this.timer.interval)
          this.timer.countDown = 60
          this.timer.countDownText = '再次获取'
        }
      }, 1000)
    },
    /**
     * @description: 下一步
     */
    nextStep(isJump) {
      if (isJump) { //只进行步骤跳转
        if (this.active < 2) this.active++
        return
      }
      if (this.formValidate()) return
      if (this.active === 0) { //绑定/验证手机号
        this.checkCode()
      } else if (this.active === 1) { //设置新密码
        this.updatePassword()
      } else if (this.active === 2) { //设置成功
        this.logout()
      }
    },
    /**
     * @description: 上一步
     */
    previousStep() {
      if (this.active > 0) this.active--
    },
    /**
     * @description: 表单校验
     */
    formValidate() {
      let validateProps = []
      if (this.active === 0) {
        validateProps = ['mobileTm', 'mobile', 'code']
      } else if (this.active === 1) {
        validateProps = ['username', 'password', 'againPassword']
      }
      let isValidate = false
      this.$refs['formRef'].validateField(validateProps, (valid) => {
        if (valid) {
          isValidate = valid
        }
      })
      return isValidate
    },
    /**
     * @description: 关闭弹窗
     */
    closeDialog() {
      this.$emit('input', false)
    },
    /**
     * @description: 退出登录
     */
    logout() {
      localStorage.removeItem(`${ this.userInfo.uuid }_pw_weak`) //清除弱密码标记
      FaceRecognitionStorage.delFRSData()
      Cookies.remove(`${ this.userInfo.uuid }_self_verified`)
      this.userLogout()
      if (this.$route.path === '/') {
        this.$router.go(0)
      } else {
        window.location.href = window.location.origin
      }
    },
    ...mapActions([
      'userLogout'
    ])
  }
}
</script>

<style lang="scss">
.ChangePasswordBase {
  padding: 16px;
  
  footer {
    text-align: center;
    
    .el-button {
      width: 168px;
      
      &:nth-child(2) {
        margin-left: 60px;
      }
    }
  }
  
  section {
    .set_success {
      text-align: center;
      
      > img {
        width: 120px;
        
      }
      
      > p {
        font-size: 14px;
        line-height: 40px;
        color: #606266;
      }
    }
    
    .login_out {
      position: absolute;
      top: 7.5px;
      right: 16px;
    }
    
    .steps_content {
      background-color: #FAFAFA;
      padding: 16px;
      margin: 12px 0;
      
      .el-steps {
        .el-step {
          height: 24px;
          
          .el-step__head.is-finish {
            color: #303133;
            border-color: #303133;
          }
          
          .el-step__head.is-process {
            color: #38BCD5;
            border-color: #38BCD5;
          }
        }
        
        .el-step__icon {
          border: 0 none;
          width: auto;
          padding: 0 10px;
          
          > div {
            border: 1px solid;
            width: 22px;
            height: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            margin-right: 10px;
          }
          
          > span {
            font-size: 16px;
            line-height: 24px;
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/ChangePassword/indexBase.vue